import { createContext, useContext } from "react";
import type { WageBreakdownReopen } from "../../utils/navigation/wageBreakdownReturn";

/**
 * DAT-906 · The day schedule's "open this shift's breakdown again" request, left by "Back to wage
 * breakdown", for whichever table body holds the shift's row to act on once.
 */
export type WageBreakdownReopenState = {
	/** The breakdown still to reopen; `null` once applied, or when the page was not returned to. */
	pending: WageBreakdownReopen | null;
	/** Done with it — reopened, or it cannot be (the row is not on this day, wages are hidden). */
	markApplied: () => void;
};

const WageBreakdownReopenContext = createContext<WageBreakdownReopenState | null>(null);

export const WageBreakdownReopenProvider = WageBreakdownReopenContext.Provider;

/** Only the day schedule's table bodies ask; anywhere else it is a bug, so it throws. */
export const useWageBreakdownReopen = (): WageBreakdownReopenState => {
	const state = useContext(WageBreakdownReopenContext);
	if (state === null) throw new Error("useWageBreakdownReopen must be used inside the day schedule (WageBreakdownReopenProvider)");
	return state;
};
